import React, { useState } from "react";
import { Card, Avatar, Row, Col, Tooltip, Button } from "antd";
import moment from "moment";
import {
  BankOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  IdcardOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import "./ProfileWidgetV2.css";

const mockProfile = {
  name: "Sarah Johnson",
  pin: "EMP-2024-0042",
  designation: "Senior Software Engineer",
  department: "Engineering",
  dateOfJoining: "15 Jan 2021",
  dateOfConfirmation: "15 Jul 2021",
  age: 32,
  employmentStatus: "Permanent",
  location: "New York, USA",
  imageUrl: "",
};

function InfoItem({ icon: Icon, label, value, truncate }) {
  const valueContent =
    truncate && value ? (
      <Tooltip title={value}>
        <span className="profile-widget-v2__info-value-truncate">{value}</span>
      </Tooltip>
    ) : (
      value
    );
  return (
    <Col xs={12} md={12} className="profile-widget-v2__info-item-wrap">
      <div className="profile-widget-v2__info-item-inner">
        <div className="profile-widget-v2__info-icon-box">
          <Icon />
        </div>
        <div className="profile-widget-v2__info-text">
          <p className="profile-widget-v2__info-label">{label}</p>
          <p className="profile-widget-v2__info-value">{valueContent}</p>
        </div>
      </div>
    </Col>
  );
}

export function ProfileWidgetV2({ profileData }) {
  const [profile] = useState(profileData?.[0] || mockProfile);
  const [imagePreview, setImagePreview] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const initials = profile.name
    ? profile.name
      .split(" ")
      .map((n) => n[0])
      .join("")
    : "";

  return (
    <div className="profile-widget-v2">
      <div className="profile-widget-v2__card" bordered={false}>
        {/* Top: blue section with name, PIN, designation, Confirm */}
        <div className="profile-widget-v2__header">
          <div className="profile-widget-v2__header-inner">
            <div className="profile-widget-v2__avatar-wrap">
              <Avatar
                size={96}
                src={
                  imagePreview ||
                  (profile.imageurl
                    ? `${process.env.REACT_APP_IMAGE_BASE_URL || ""}${profile.imageurl}${process.env.REACT_APP_IMAGE_TOKEN_KEY || ""}`
                    : null)
                }
                className="profile-widget-v2__avatar"
              >
                {!imagePreview && !profile.imageurl ? initials : null}
              </Avatar>
              {/* <label className="profile-widget-v2__avatar-overlay">
                <CameraOutlined />
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </label> */}
            </div>
            <div className="profile-widget-v2__header-text">
              <div className="profile-widget-v2__header-name-row">
                <h2 className="profile-widget-v2__name">{profile.name}</h2>
                <span className="profile-widget-v2__pin-badge">{profile.pin}</span>
              </div>
              <p className="profile-widget-v2__designation">{profile.designation}</p>
              <div className="profile-widget-v2__meta">
                <span className="profile-widget-v2__status-badge">
                  {profile.employmentstatus}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom section part 1: Department, Location */}
        <div className="profile-widget-v2__info-section profile-widget-v2__info-section--top">
          <Row gutter={[16, 0]} className="profile-widget-v2__info-grid">
            <InfoItem
              icon={BankOutlined}
              label="Department"
              value={profile.department}
            />
             <InfoItem
              icon={CalendarOutlined}
              label="Date of Joining"
              value={
                profile.dateofjoining
                  ? moment(profile.dateofjoining).format("DD MMM YYYY")
                  : ""
              }
            />
          </Row>
        </div>

        {/* Bottom section part 2: Date of Confirmation, Age, Location */}
        <div className="profile-widget-v2__info-section profile-widget-v2__info-section--bottom">
          <Row gutter={[16, 18]} className="profile-widget-v2__info-grid">
          <InfoItem
              icon={EnvironmentOutlined}
              label="Location"
              value={profile.location}
              truncate
            />
            <InfoItem
              icon={CalendarOutlined}
              label="Date of Confirmation"
              value={
                profile.dateofconfirmation
                  ? moment(profile.dateofconfirmation).format("DD MMM YYYY")
                  : ""
              }
            />
            
          </Row>
        </div>
      </div>
    </div>
  );
}
